import '../index.css';

import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { connect } from 'react-redux';

import getUniqueFieldVersion from '../../../graphql/queries/getUniqueFieldVersion.graphql';
import { SearchActionButtonSection } from '../../search/actionSection';
import SearchTable from '../../search/search-table';

function stateToComponent(state) {
  return {
    who: state.who
  };
}

function actionSection(actions) {
  return [
    {
      icon: 'eye',
      label: 'View Version',
      action: actions.version
    }
  ];
}

@connect(stateToComponent)
@graphql(getUniqueFieldVersion, {
  name: 'uniqueFieldVersion',
  options: (props) => {
    const { id } = props.match.params;

    return {
      fetchPolicy: 'cache-and-network',
      errorPolicy: 'all',
      context: {},
      variables: {
        id
      }
    };
  }
})
class UniqueFieldView extends Component {
  historyTableModel = [
    {
      label: 'Version',
      property: 'version',
      type: 'string'
    },
    {
      label: 'Date',
      property: 'updatedAt',
      type: 'date'
    },
    {
      label: 'Action',
      property: 'method',
      type: 'string'
    },
    {
      label: 'Actions',
      type: 'component',
      component: SearchActionButtonSection,
      model: actionSection
    }
  ];

  loadUniqueFieldVersion = (uniqueField) => {
    const { history } = this.props;
    const { id } = this.props.match.params;
    history.push(`/uniqueField/history/${id}/version/${uniqueField.version}`);
  };

  render() {
    const { uniqueFieldVersion } = this.props;
    if (uniqueFieldVersion.loading) {
      return <div />;
    }

    const diffs = uniqueFieldVersion.uniqueFieldVersionById.diffs;

    return (
      <SearchTable
        who={null}
        items={diffs}
        model={this.historyTableModel}
        actions={{
          version: this.loadUniqueFieldVersion
        }}
        area="history"
      />
    );
  }
}

export default UniqueFieldView;
